import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f18f1330&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f18f1330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f1330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f18f1330')) {
      api.createRecord('f18f1330', component.options)
    } else {
      api.reload('f18f1330', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f18f1330&scoped=true&", function () {
      api.rerender('f18f1330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8JhPQrTrPNJ/JS/comp/SearchFilterTokens.vue"
export default component.exports